import api from './../../service/apiService'
import { apiUrl } from './../../constants/apiUrl'
import { logKafka, catchJSException } from './../../service/logService';
import { Save } from './../../constants/actionType';
import { updateSCcustomEvent, tempSCData } from './../../service/dtmTag';
import { errorAction } from './error';
import { InHomeUtils } from './../../util/inhomeUtils';

export const helpSaveOverlay = (status, dispatch) => {
    dispatch({ type: Save.helpSave, value: status })
};

export const resumeSavedMon = (dispatch, action) => {
    dispatch({ type: Save.resumeSavedMon, value: action });
}

export const sendCartNum = (dispatch, action) => {
    dispatch({ type: Save.sendCartNum, value: action });
}

export const saveModalInput = (dispatch, action) => {
    dispatch({ type: Save.saveModalInput, value: action });
}
export const saveInvoked = (status, dispatch) => {
    dispatch({ type: Save.saveInvoked, value: status })
};

export const creditDone = (status, dispatch) => {
    dispatch({ type: Save.creditDone, value: status })
};

export const expiryDate = (status, dispatch) => {
    dispatch({ type: Save.expiryDate, value: status })
};

export const validateInput = (status, dispatch) => {
    dispatch({ type: Save.validateInput, value: status })
};

export const saveLqEmailInput = (dispatch, status) => {
    dispatch({ type: Save.saveLqEmailInput, value: status })
};

export const saveLqMtnInput = (dispatch, status) => {
    dispatch({ type: Save.saveLqMtnInput, value: status })
};

export const emailError = (status, dispatch) => {
    dispatch({ type: Save.emailError, value: status })
};

export const mtnError = (status, dispatch) => {
    dispatch({ type: Save.mtnError, value: status })
};

export const resumeMonErr = (status, dispatch) => {
    dispatch({ type: Save.resumeMonErr, value: status })
};

export const sendCartErr = (status, dispatch) => {
    dispatch({ type: Save.sendCartErr, value: status })
};

export const resumeMonValueErr = (status, dispatch) => {
    dispatch({ type: Save.resumeMonValueErr, value: status })
};

export const resumeMonAttemptErr = (status, dispatch) => {
    dispatch({ type: Save.resumeMonAttemptErr, value: status })
};

export const sendCartEmailErr = (status, dispatch) => {
    dispatch({ type: Save.sendCartEmailErr, value: status })
};

export const sendCartMTNErr = (status, dispatch) => {
    dispatch({ type: Save.sendCartMTNErr, value: status })
};

export const sentSmsorEmail = (status, dispatch) => {
    dispatch({ type: Save.sentSmsorEmail, value: status })
};

export const resumeInternetAdded = (dispatch, action) => {
    dispatch({ type: Save.resumeInternetAdded, value: action });
}
export const resumeTvAdded = (dispatch, action) => {
    dispatch({ type: Save.resumeTvAdded, value: action });
}
export const resumeVoiceAdded = (dispatch, action) => {
    dispatch({ type: Save.resumeVoiceAdded, value: action });
}
export const cancelSmartCartClick = (status, dispatch) => {
    dispatch({ type: 'CANCEL_SMARTCARTCLICK', value: status })
};


export const sendSmsOrEmail = (visitId, dispatch, mon, smsOrEmail, isMtn) => {
    try {
        if(visitId){
            let requestJson = sendRequest(mon, smsOrEmail, isMtn,visitId);
            let url = apiUrl().sendSmsOrEmail;        
            api(url, 'POST', requestJson).then(response => {
                if(InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, "200")) {
                    dispatch({ type: Save.sendSmsorEmail, value: response.data });
                    sentSmsorEmail(true, dispatch);
                }
            })
            .catch(error => {
                let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                let errorMsg = `MethodName:sendSmsOrEmail,errorMessage:${error.message}`;
                logKafka("ERROR", "SAVECART", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
        }
    }
    catch (ex) {
        catchJSException('smartSave', visitId, 'action-sendSmsOrEmail', ex);
    }
};

export const smartCartSaveWithParam = (dispatch, visitId, smsOrEmail, isMtn, mon, isCreditCompleted, saveLQEmailInfo) => {
    try {
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "Saving your cart", isLoaderImg: "loader" }
        });
        let prospectUpdate = false;
        if (saveLQEmailInfo === "") {
            prospectUpdate = true;
        }
        else if (!isMtn && smsOrEmail !== "" && saveLQEmailInfo !== smsOrEmail) {
            prospectUpdate = true;
        }
        let url = apiUrl().smartSave;
        let request = {
            email: !isMtn ? smsOrEmail : "",
            mtn: isMtn ? smsOrEmail : "",
            saveType: 'proactive',
            prospectUpdate: prospectUpdate ? "Y" : "",
        }
        api(url, 'POST', JSON.stringify(request)).then(response => {
            if(InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta)){
                if (InHomeUtils.getIndexOf(response.meta.code, "200")) {
                    dispatch({ type: Save.smartSave, value: response.meta.description });
                    saveInvoked(true, dispatch)
                    if (mon !== "") {
                        sendSmsOrEmail(visitId, dispatch, mon, smsOrEmail, isMtn);
                    }
                    tempSCData.detailPageName = "smart cart confirmation| " + ((isCreditCompleted) ? " post credit" : " pre credit");
                    tempSCData.events = "event5,event22";
                    tempSCData.MON = mon;
                    updateSCcustomEvent("saveProactive", "ddPageViewUpdateEvent", "detailPageName,events");
                }
                else if (InHomeUtils.getIndexOf(response.meta.code, "500")) {
                    errorAction("LBO", "smartCartSaveWithParam", "SaveOrderFail", "applogs", visitId, dispatch, true, "SaveOrderFail");
                }
                else if (InHomeUtils.getIndexOf(response.meta.code, "400")) {
                    errorAction("LBO", "smartCartSaveWithParam", "SaveOrderFail", "applogs", visitId, dispatch, true, "SaveOrderFail");
                }
            }
            
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
        .catch(error => {
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            let errorMsg = `MethodName:smartCartSaveWithParam,errorMessage:${error.message}`;
            logKafka("ERROR", "smartCartSaveWithParam", errorMsg, getErrorLogUrl, "applogs", visitId);
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        });
    }
    catch (ex) {
        catchJSException('smartSave', visitId, 'action-smartCartSaveWithParam', ex);
    }
};
export const getHTMLContent = (dispatch,  isHeader) => {
    const url  = isHeader ? apiUrl().ecHeader : apiUrl().ecFooter;
    api(url, 'GET','', 'html' ).then(response => {
        const content = {
            type: isHeader ? 'EC_HEADER' : 'EC_FOOTER',
            value: response
        }
        dispatch(content);
    }).catch(error => {
        console.log('html error', error);
    });
}

export const smartSave = (dispatch, visitId, saveType, isCreditCompleted, isSaveContinueClick, mon, smsOrEmail, isMtn) => {

    try {
        // if (saveType === "passive") {
        //     tempSCData.detailPageName = "smart cart save passive|" + ((isCreditCompleted) ? " post credit" : " pre credit");
        //     updateSCcustomEvent("savePassive", "ddPageViewUpdateEvent", "detailPageName");
        // }

        if (isSaveContinueClick) {
            dispatch({
                type: 'LOADER_ACTIVE',
                value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
            });
        }
        let url = apiUrl().smartAutoSave;
        api(url, 'GET', '').then(response => {
            if(InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, "200")) {
                dispatch({ type: Save.smartSave, value: response.meta.description });

                if (isSaveContinueClick) {
                    saveInvoked(true, dispatch)
                    if (mon !== "") {
                        sendSmsOrEmail(visitId, dispatch, mon, smsOrEmail, isMtn);
                    }
                    expiryDate(saveDate(), dispatch)
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                }
            }
        })
        .catch(error => {
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            let errorMsg = `MethodName:smartSave,errorMessage:${error.message}`;
            logKafka("ERROR", "SAVECART", errorMsg, getErrorLogUrl, "applogs", visitId);
            if (isSaveContinueClick) { dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } }); }
        });
    }
    catch (ex) {
        catchJSException('smartSave', visitId, 'action-smartSave', ex);
    }
};

// removed unwanted SmartCart code   
export const smartcartflow = (dispatch, value) => {
    dispatch({ type: Save.issmartcartFlow, value: value });
};

const sendRequest = (mon, smsOrEmail, isMtn,visitId) => {
    try{
        let today = new Date();
        let mm = today.getMonth() + 1;
        if (mm < 10) { mm = "0" + mm; }
        let dd = today.getDate();
        if (dd < 10) { dd = "0" + dd; }
        let y = today.getFullYear();
        let savedate = mm + '/' + dd + '/' + y;
        let request = {
            email: !isMtn ? smsOrEmail : "",
            mtn: isMtn ? smsOrEmail : "",
            mon: mon,
            deliveryType: isMtn ? "SMS" : "EMAIL",
            cartCreateDate: savedate
        }
        return JSON.stringify(request);
    }
    catch (ex) {
        catchJSException('submitOrder', visitId, 'action-sendRequest', ex);
        return JSON.stringify({ email: "", mtn: "", mon: "", deliveryType: "", cartCreateDate: "" });
    }
}

export const saveDate = (visitId) => {
    try{
        let today = new Date();
        let newdate = new Date();
        newdate.setDate(today.getDate() + 9);
        let dd = newdate.getDate();
        if (dd < 10) {
            dd = "0" + dd;
        }
        let mm = newdate.getMonth() + 1;
        if (mm < 10) { mm = "0" + mm; }
        let y = newdate.getFullYear();
        let savedate = mm + '/' + dd + '/' + y;
        return savedate;
    }
    catch (ex) {
        catchJSException('submitOrder', visitId, 'action-saveDate', ex);
        return '';
    } 
}